export default __webpack_public_path__ + "static/media/DNo.24-2.2afd05bc.jpg";